export enum OverhangType {
  Down = 'down',
  Out = 'out',
}
